// Galeria de miniaturas dos cards de produto.
// - Clique na miniatura troca a imagem principal.
// - Hover na imagem principal mostra a 2a imagem (e volta ao tirar).
// - Esteira no clique: ao clicar na ULTIMA miniatura visivel, a tira "encaixa" um passo —
//   a proxima entra no lugar dela, todas deslizam uma posicao para a esquerda e a primeira
//   sai pela esquerda e some (vai para o fim, em loop).
// Carregado UMA vez por pagina (via scripts.liquid) e usa delegacao de eventos,
// entao funciona em home, collection e carrinho sem duplicar.
(function () {
  if (window.__tgReady) return;
  window.__tgReady = true;

  function setImg(img, src, srcset) {
    if (!img || !src) return;
    img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset);
    else img.removeAttribute('srcset');
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Avanca a tira um passo: a primeira desliza pra fora (esquerda) e reaparece no fim (loop).
  function advance(track) {
    if (track.dataset.animating) return;
    var first = track.firstElementChild;
    if (!first) return;
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '8') || 8;
    var step = first.getBoundingClientRect().width + gap;
    track.dataset.animating = '1';
    track.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
    track.style.transform = 'translateX(-' + step + 'px)';
    var done = function () {
      track.removeEventListener('transitionend', done);
      track.style.transition = 'none';
      track.style.transform = 'none';
      track.appendChild(first); // a primeira reaparece no fim (loop)
      void track.offsetWidth; // forca reflow pra o reset nao animar
      track.style.transition = '';
      track.removeAttribute('data-animating');
    };
    track.addEventListener('transitionend', done);
    // Fallback caso o transitionend nao dispare (aba em background etc.)
    setTimeout(function () { if (track.dataset.animating) done(); }, 800);
  }

  // --- Clique: troca a imagem principal (e avanca a esteira se for a ultima visivel) ---
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest ? e.target.closest('.tg__thumb') : null;
    if (!thumb) return;
    e.preventDefault();
    e.stopPropagation();
    var tg = thumb.closest('.tg');
    if (!tg) return;
    var main = tg.querySelector('.tg__main-img');
    setImg(main, thumb.getAttribute('data-full'), thumb.getAttribute('data-srcset'));
    var thumbs = tg.querySelectorAll('.tg__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', thumbs[i] === thumb);
    }
    if (main) {
      main.removeAttribute('data-current-src');
      main.removeAttribute('data-current-srcset');
    }

    // Esteira: so avanca se clicou na ultima miniatura visivel da janela.
    var vp = thumb.closest('.tg__thumbs--cycle');
    if (!vp || prefersReducedMotion()) return;
    var li = thumb.closest('.tg__thumb-item');
    var track = vp.querySelector('.tg__track');
    if (!li || !track || track.children.length < 2) return;
    var next = li.nextElementSibling;
    var vpRight = vp.getBoundingClientRect().right;
    var tol = 2;
    var liRight = li.getBoundingClientRect().right;
    var nextRight = next ? next.getBoundingClientRect().right : Infinity;
    // Avanca se clicou na ultima miniatura TOTALMENTE visivel (a "3a", cuja proxima ja transborda)
    // ou na palhinha da proxima (que ja esta clipada na borda direita).
    var clickedClipped = liRight > vpRight + tol;
    var lastFullyVisible = liRight <= vpRight + tol && nextRight > vpRight + tol;
    if (clickedClipped || lastFullyVisible) advance(track);
  });

  // --- Setas sobre a imagem: passa pela imagem anterior/próxima do produto ---
  document.addEventListener('click', function (e) {
    var nav = e.target.closest ? e.target.closest('.tg__nav') : null;
    if (!nav) return;
    e.preventDefault();
    e.stopPropagation();
    var tg = nav.closest('.tg');
    if (!tg) return;
    var thumbs = tg.querySelectorAll('.tg__thumb');
    if (!thumbs.length) return;
    var active = tg.querySelector('.tg__thumb.is-active') || thumbs[0];
    var idx = Array.prototype.indexOf.call(thumbs, active);
    var dir = nav.classList.contains('tg__nav--next') ? 1 : -1;
    var target = thumbs[(idx + dir + thumbs.length) % thumbs.length];
    var main = tg.querySelector('.tg__main-img');
    setImg(main, target.getAttribute('data-full'), target.getAttribute('data-srcset'));
    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('is-active', thumbs[i] === target);
    if (main) {
      main.removeAttribute('data-current-src');
      main.removeAttribute('data-current-srcset');
    }
  });

  // --- Hover na imagem principal: mostra a 2a imagem ---
  document.addEventListener('mouseover', function (e) {
    var mainEl = e.target.closest ? e.target.closest('.tg__main') : null;
    if (!mainEl) return;
    var hov = mainEl.getAttribute('data-hover-src');
    if (!hov) return;
    var img = mainEl.querySelector('.tg__main-img');
    if (!img) return;
    if (!img.hasAttribute('data-current-src')) {
      img.setAttribute('data-current-src', img.getAttribute('src') || '');
      img.setAttribute('data-current-srcset', img.getAttribute('srcset') || '');
    }
    setImg(img, hov, mainEl.getAttribute('data-hover-srcset'));
  });
  document.addEventListener('mouseout', function (e) {
    var mainEl = e.target.closest ? e.target.closest('.tg__main') : null;
    if (!mainEl) return;
    if (e.relatedTarget && mainEl.contains(e.relatedTarget)) return;
    var img = mainEl.querySelector('.tg__main-img');
    if (!img || !img.hasAttribute('data-current-src')) return;
    setImg(img, img.getAttribute('data-current-src'), img.getAttribute('data-current-srcset'));
    img.removeAttribute('data-current-src');
    img.removeAttribute('data-current-srcset');
  });
})();
